export const cpfFormatter = (data: string) => {
  const one = data.slice(0, 3);
  const two = data.slice(3, 6);
  const three = data.slice(6, 9);
  const four = data.slice(9, 12);
  return `${one}.${two}.${three}-${four}`;
};
